import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import { setHTMLMessage,clearMessage } from '../tools/errorhandling';
import * as connector from "../dbconnector/connector";
import reports from "./reports.json";

const TriggersReports = (props) => {

    const t = props.translation;
    const [selectedReportKey, setSelectedReportKey] = useState('');
    const [formValues, setFormValues] = useState({});

    const selectedReport = reports.find(r => r.key === selectedReportKey);

    const handleReportChange = (e) => {
        const key = e.target.value;
        setSelectedReportKey(key);
        const report = reports.find(r => r.key === key);
        if (report) {
            const initialValues = {};
            report.params.forEach(p => {
                if (p.permanent !== null && p.permanent !== undefined) {
                    initialValues[p.name] = p.permanent;
                } else if (p.default !== undefined) {
                    initialValues[p.name] = p.default;
                } else {
                    initialValues[p.name] = '';
                }
            });
            setFormValues(initialValues);
        } else {
            setFormValues({});
        }
    };

    const handleParamChange = (name, value) => {
        setFormValues(prev => ({ ...prev, [name]: value }));
    };

    const triggerReportClick = () => {
        if (!selectedReport) {
            setHTMLMessage("No report selected");
            return;
        }
        const args = selectedReport.params.map(p => {
            const val = formValues[p.name];
            return (p.permanent !== null && p.permanent !== undefined) ? p.permanent : (val !== undefined ? val : p.default);


        });

        const func = connector[selectedReport.connector];
        if (typeof func === 'function') {
            func(...args).then(response => {
                if (response.status === 200) {
                    setHTMLMessage("Report triggered successfully");
                } else {
                    setHTMLMessage("Error triggering report");
                }
            });
        } else {
            console.error("Connector function not found");
        }
    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div id="return" className="form">
                    <h1 className="title">{t('Raporten')}</h1>
                    <div className="form-group">
                        <label htmlFor="reportSelect">{t('Report')}</label>
                        <select id="reportSelect" className="form-control" value={selectedReportKey} onChange={handleReportChange}>
                            <option value="">{t('Select report')}</option>
                            {reports.map(report => (
                                <option key={report.key} value={report.key}>{t(report.label)}</option>
                            ))}
                        </select>
                    </div>
                    {selectedReport && selectedReport.params.map(param => (
                        <div className="form-group" key={param.name}>
                            <label htmlFor={`param-${param.name}`}>{t(param.label)}</label>
                            <input
                                id={`param-${param.name}`}
                                type={param.type}
                                className="form-control"
                                value={formValues[param.name] || ''}
                                onChange={e => handleParamChange(param.name, e.target.value)}
                                disabled={param.permanent !== null && param.permanent !== undefined}
                            />
                        </div>
                    ))}
                    {selectedReport && (
                        <Button onClick={triggerReportClick} type="button" className="Savebutton btn btn-primary margin-right" >
                            {t(selectedReport.buttonLabel || 'Trigger')}
                        </Button>
                    )}
                </div>
            </div>
        </>
    )
}

export default TriggersReports;
